import React from 'react'
import { Fragment } from 'react'
import banner from '../../Assets/Images/banner.png'

const TopBanner = ({ title }) => {
    return (
        <Fragment>
            <section className='topBanner'>
                <div className=" container d-flex align-items-center h-100">
                    <div className="row">
                        <div className="col-12">
                            <h1 className='text-light fw-bold'>{title}</h1>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default TopBanner